<script>
import { VCounter } from 'vuetify/lib'
import { functionalThemeClasses } from 'vuetify/lib/mixins/themeable'

export default {
  name: 'ECounter',
  extends: VCounter,
  render(h, ctx) {
    const { props } = ctx
    const max = parseInt(props.max, 10)
    const value = parseInt(props.value, 10)
    const content = max ? `${value}/${max}` : String(props.value)
    const isGreater = max && value > max
    return h(
      'div',
      {
        staticClass: 'v-counter',
        class: {
          'error--text': isGreater,
          ...functionalThemeClasses(ctx),
        },
      },
      content
    )
  },
}
</script>
